var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50005 0.5C4.0815 0.5 0.5 3.27943 0.5 6.7074C0.5 8.83931 1.88525 10.7187 3.9947 11.8366L3.10715 15.0933C3.02873 15.3811 3.35638 15.6104 3.60798 15.4437L7.49856 12.8645C7.82688 12.8963 8.16054 12.9149 8.50005 12.9149C12.9182 12.9149 16.5 10.1355 16.5 6.7074C16.5 3.27943 12.9182 0.5 8.50005 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoLogo);
export default __webpack_public_path__ + "static/media/kakaoLogo.37104b7778392dca230a17fae35c20f0.svg";
export { ForwardRef as ReactComponent };